import gql from "graphql-tag";

export const createPerk = gql`
  mutation CreatePerk($data: PerkCreateInput!) {
    createPerk(data: $data){
      id
    }
  }
`;